import { JsonPatchOperation } from './patch-helpers.service';

/**
 * System-wide patch operation filter for server-computed PersonName fields.
 *
 * PersonName.fullName, PersonName.suppressed, and PersonName.display are derived
 * by the API and rejected by the PATCH endpoint if sent. They appear on any model
 * that carries a partyName: PersonName sub-object (parties, participants, etc.).
 *
 * Applied internally by PatchHelpersService.generatePatchOperations — callers do not
 * need to apply it explicitly. Feature-specific filters (e.g. isClerkReviewBusinessOpAllowed)
 * should still be applied at the call site after generatePatchOperations returns.
 *
 * Coverage note: DraftFilingSessionService.setDraftFilingData strips these three fields
 * from both session snapshots before they reach generatePatchOperations, so for FilingDraft
 * paths this filter is belt-and-suspenders (the compare never emits these ops). For
 * ClerkReviewFiling the session data is not stripped, making this filter the primary
 * enforcement gate. Do not remove it assuming the session stripping is sufficient —
 * that stripping only applies to FilingDraft.
 *
 * TODO: Remove once PersonName's computed fields are annotated with [PatchDisabled]
 * on the backend and patch-constraints.ts is regenerated. At that point
 * PATCH_OBJECT_LINKS will carry partyName -> PersonName type links and
 * isPathAllowed will block sub-field paths automatically.
 *
 * For system-wide filters: add them here.
 * For feature-specific filters: use the filter for the service in question
 *   (e.g. clerk-review-business-filter.ts, filing-specific filter, etc.).
 */
export function isAppPatchOpAllowed(op: JsonPatchOperation): boolean {
  return (
    !op.path.endsWith('/partyName/fullName') &&
    !op.path.endsWith('/partyName/suppressed') &&
    !op.path.endsWith('/partyName/display')
  );
}
